import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], subtotal: 0, tax: 0, total: 0 });

  const refresh = useCallback(async () => {
    if (!user) { setCart({ items: [], subtotal: 0, tax: 0, total: 0 }); return; }
    try { const { data } = await api.get("/cart"); setCart(data); } catch {}
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const add = async (product_id, opts = {}) => {
    if (!user) throw new Error("Please login");
    await api.post("/cart/add", { product_id, quantity: opts.quantity || 1, size: opts.size, color: opts.color });
    await refresh();
  };
  const remove = async (product_id, opts = {}) => {
    await api.post("/cart/remove", { product_id, size: opts.size, color: opts.color });    await refresh();
  };
  const clear = async () => { await api.post("/cart/clear"); await refresh(); };
  const setQty = async (product_id, quantity, opts = {}) => {
    await api.post("/cart/update", { product_id, quantity: Math.max(1, quantity), size: opts.size, color: opts.color });
    await refresh();
  };

  return (
    <CartCtx.Provider value={{ cart, refresh, add, remove, clear, setQty, count: cart.items.reduce((a, b) => a + (b.quantity || 0), 0) }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
